import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "public-components",
      meta: { transition: "fade" },
      components: {
        header: AppHeader,
        default: () => import("./views/Main.vue"),
        footer: AppFooter,
      },
    },
    {
      path: "/info",
      name: "public-info",
      meta: { transition: "slide-left" },
      components: {
        header: AppHeader,
        default: () => import("./views/Info.vue"),
        footer: AppFooter,
      },
    },
    {
      path: "/entities",
      name: "public-entities",
      meta: { transition: "slide-left" },
      components: {
        header: AppHeader,
        default: () => import("./views/Entities.vue"),
        footer: AppFooter,
      },
    },
    {
      path: "/contacts",
      name: "public-contacts",
      meta: { transition: "slide-left" },
      components: {
        header: AppHeader,
        default: () => import("./views/Contacts.vue"),
        footer: AppFooter,
      },
    },
    {
      path: "/search",
      name: "public-search",
      meta: { transition: "slide-left" },
      components: {
        header: AppHeader,
        default: () => import("./views/Search.vue"),
        footer: AppFooter,
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
